module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_9005.47f61792.png";